export const setToken = (token, rememberMe) => {
  const expirationTime = rememberMe
    ? new Date().getTime() + 7 * 24 * 60 * 60 * 1000 // 7 days in ms
    : new Date().getTime() + 1 * 60 * 60 * 1000; // 1 hour in ms

  const tokenData = {
    token,
    expiresAt: expirationTime,
    rememberMe: rememberMe,
  };

  localStorage.setItem("auth", JSON.stringify(tokenData));
};

export const getToken = () => {
  const storedData = JSON.parse(localStorage.getItem("auth"));

  if (storedData) {
    const currentTime = new Date().getTime();

    if (currentTime < storedData.expiresAt) {
      return storedData.token;
    } else {
      removeToken();
      return null; // Token expired
    }
  }
  return null; // No token found
};

export const removeToken = () => {
  localStorage.clear();
};
